import React, {useState} from 'react';


function App(props) {  

    return (
        <div className="title animate" data-animate="blendin 3s" id={props.id}>
       
                <div className="title-content">
                   
                    <img className="logo" src="./images/mco_logo.png" />
                    
                    <div className="main-subtitle">Wir heißen Sie willkommen.</div>
                    <div className=" main-title text-variable text-break">
                        <div className="">Männerchor 1861 </div> 
                        <div className="">&#160;Opperode e.V.</div> 
                    </div>
                    <div className="text-item text-variable ">Zusammen singen, zusammen bleiben.</div>
                    <div className="text-item text-variable "></div>
                </div>
            
        </div>
      
        );
}

export default App;